import { CheckCreator, FormValues } from 'lib/utils/formValidation';
import isEmpty from 'lib/utils/formValidation/isEmpty';

/*
  We don't want to surface validation errors until all values to be matched are entered.
  Therefore, we short-circuit the validation if any of the values of interest are missing.
*/
const areValuesMatching: CheckCreator =
  (fieldNames: string[]) => (_, allValues: FormValues | undefined) => {
    const values = fieldNames.map((name) => allValues?.[name]);
    const hasMissingValue = values.some((value) => isEmpty(value));
    const allValuesMatch = new Set(values).size === 1;

    return hasMissingValue || allValuesMatch;
  };

export default areValuesMatching;
